import {Component, OnInit} from '@angular/core';
import {HiringRequestService} from '../../../api/hiringrequest/hiringrequest.service';
import {Router} from '@angular/router';
import 'rxjs/add/operator/catch';
import { Title } from '@angular/platform-browser';
declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'application-page',
    templateUrl: './hiringrequest.html'
})

export class HiringRequest implements OnInit {
    hiring = [];
    id : string;
    i : number;


    constructor(private hiringRequestService: HiringRequestService,
                private router: Router ,private titleService : Title) {
    }

    ngOnInit() {
        this.titleService.setTitle("Hiring Request  | Phoenix Games");
        if (localStorage.getItem('token') && localStorage.getItem('role') == 'SUPERADMIN') {
            this.hiringRequestService.allHiring()
                .then(data => {
                    this.hiring = data;
                });
        } else {
            this.router.navigate(['/']);
        }
    }

    downloadCoverletter(name) {
        this.hiringRequestService.downloadFile(name);
    }
    deleteconfirmation(id , i){
        this.id = id;
        this.i = i;

    }
    cancelAction(){
        this.i = null;
        this.id = " ";
    }

    deletehiringrequest(){
        this.hiringRequestService.dhiringrequest(this.id).then(data => {
          
            if (data.status) {
                this.hiring.splice(this.i, 1);
                $.notify({
                    message: "Successfully Deleted"
                }, {
                    type: 'success',
                    placement: {
                        from: 'bottom',
                        align: 'right'
                    },
                    delay: 100,
                    timer: 100
                });
            } else {
                this.cancelAction();
            }
        });
    }
}





// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/hiringrequest/hiringrequest.page.ts